<script setup lang="ts">
import { UserCircleIcon } from "lucide-vue-next"

import type { User } from "@/types"

interface Props {
  user: User
  showEmail?: boolean
}

withDefaults(defineProps<Props>(), {
  showEmail: false,
})
</script>

<template>
  <UserCircleIcon class="size-6 overflow-hidden" />
  <div class="grid flex-1 text-left text-base leading-tight">
    <span class="truncate font-medium">{{ user.short_name }}</span>
    <span v-if="showEmail" class="text-muted-foreground truncate text-xs">
      {{ user.email }}
    </span>
  </div>
</template>
